var _defs, _g, _path, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #636793;\n      }\n\n      .st1 {\n        fill: #f6f6f6;\n      }\n\n      .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #e0e0e0;\n      }\n\n      .st4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st5 {\n        fill: #afb4e8;\n      }\n\n      .st6 {\n        fill: #d8d8d8;\n      }\n\n      .st7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st8 {\n        fill: #fff;\n        font-family: MyriadPro-Bold, 'Myriad Pro';\n        font-size: 12px;\n        font-weight: 700;\n      }\n\n      .st9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st10 {\n        clip-path: url(#clippath);\n      }\n\n      .st11 {\n        fill: #787cb4;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 5.33,
    y: 0,
    width: 53.33,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 5.33,
    y: 24,
    width: 53.33,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12,63.33c-3.31,0-6-2.69-6-6V6.67c0-3.31,2.69-6,6-6h31.72l14.28,14.28v42.39c0,3.31-2.69,6-6,6H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0ZM43.45,1.33l13.89,13.89v42.11c0,2.94-2.39,5.33-5.33,5.33H12c-2.94,0-5.33-2.39-5.33-5.33V6.67c0-2.94,2.39-5.33,5.33-5.33h31.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.91,12.67l12.91,12.91v-12.91h-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.67,14.67h-8c-3.68,0-6.67-2.98-6.67-6.67V0h14.67v14.67Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,63.33c-3.31,0-6-2.69-6-6V6.67c0-3.31,2.69-6,6-6h31.72l14.28,14.28v42.39c0,3.31-2.69,6-6,6H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0ZM43.45,1.33l13.89,13.89v42.11c0,2.94-2.39,5.33-5.33,5.33H12c-2.94,0-5.33-2.39-5.33-5.33V6.67c0-2.94,2.39-5.33,5.33-5.33h31.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.67,36H16c-1.1,0-2-.9-2-2s.9-2,2-2h32.67c1.1,0,2,.9,2,2s-.9,2-2,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.67,44H16c-1.1,0-2-.9-2-2s.9-2,2-2h32.67c1.1,0,2,.9,2,2s-.9,2-2,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.67,52H16c-1.1,0-2-.9-2-2s.9-2,2-2h18.67c1.1,0,2,.9,2,2s-.9,2-2,2"
  })))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(11.8 16.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PHP"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.cc4a4be9a5b327b51013610040594c87.svg";
export { ForwardRef as ReactComponent };